import { cx } from '@linaria/core';
import { getCaptionValue } from '@pm2/content-engine';
import { pm2ConfigStore } from '@pm2/store';
import { captionCls, titleCls, spanCls } from './styles/Caption.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function Caption(props) {
  const audience = pm2ConfigStore.useSelector(state => state.config.theme.targetAudience);
  const content = extractCaptionContent(props.caption);
  const title = props.displayInternalInfoInPlayer ? undefined : content.title;
  const description = props.displayInternalInfoInPlayer ? undefined : content.description;
  const displayCaption = title || description || content.authorOrArtist || content.country || content.duration || content.year || content.copyright;
  if (!displayCaption) {
    return null;
  }
  return /*#__PURE__*/jsxs("div", {
    className: cx(captionCls, props.isScrambled && "scrambled", props.displayCaption, audience === "Grade1To3" && "simple"),
    children: [title && /*#__PURE__*/jsx("span", {
      className: cx(titleCls, spanCls),
      dangerouslySetInnerHTML: {
        __html: title
      }
    }), description && /*#__PURE__*/jsx("span", {
      className: spanCls,
      dangerouslySetInnerHTML: {
        __html: description
      }
    }), content.caption && /*#__PURE__*/jsx("span", {
      className: spanCls,
      dangerouslySetInnerHTML: {
        __html: content.caption
      }
    }), content.authorOrArtist && /*#__PURE__*/jsx("span", {
      className: spanCls,
      dangerouslySetInnerHTML: {
        __html: content.authorOrArtist
      }
    }), content.country && /*#__PURE__*/jsx("span", {
      className: spanCls,
      dangerouslySetInnerHTML: {
        __html: content.country
      }
    }), content.duration && /*#__PURE__*/jsx("span", {
      className: spanCls,
      dangerouslySetInnerHTML: {
        __html: content.duration
      }
    }), content.year && /*#__PURE__*/jsx("span", {
      className: spanCls,
      dangerouslySetInnerHTML: {
        __html: content.year
      }
    }), content.copyright && /*#__PURE__*/jsx("span", {
      className: spanCls,
      dangerouslySetInnerHTML: {
        __html: "©&nbsp;" + content.copyright
      }
    })]
  });
}
function extractCaptionContent(caption) {
  return Object.fromEntries(Object.entries(caption).map(([key, property]) => [key, getCaptionValue(property)]));
}

export { Caption };
//# sourceMappingURL=Caption.js.map
